import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { Button } from '@orijinworks/frontend-commons';
import QueueStatusChip from '../queue-status-chip/queue-status-chip';
import { QUEUE_STATUS } from '../../constants/lms-course-review.constants';
import { formatSuggestionScore, isHighConfidenceLinkable } from '../../utils/lms-course-review.utils';

export { QueueSelectCell } from './queue-select-cell';

/**
 * Status cell renderer for the queue grid.
 */
export const QueueStatusCell = ({ item }) => (
  <QueueStatusChip reviewStatus={item.reviewStatus} status={item.status} />
);

QueueStatusCell.propTypes = {
  item: PropTypes.shape({
    reviewStatus: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
};

/**
 * Action cell renderer for the queue grid.
 */
export const QueueActionCell = ({ item, onOpenResolution, onInlineAccept }) => {
  const isPending = item.status === QUEUE_STATUS.PENDING;

  if (!isPending) {
    return (
      <Button
        color="default"
        variant="outlined"
        size="small"
        data-testid={`view-queue-item-${item.id}`}
        onClick={() => onOpenResolution(item)}
      >
        View
      </Button>
    );
  }

  const canInlineAccept = Boolean(onInlineAccept) && isHighConfidenceLinkable(item);
  const score = formatSuggestionScore(item?.suggestedResource?.score);

  return (
    <Box display="inline-flex" alignItems="center" style={{ gap: 8 }}>
      {canInlineAccept && (
        <Button
          color="primary"
          variant="contained"
          size="small"
          data-testid={`accept-queue-item-${item.id}`}
          onClick={() => onInlineAccept(item)}
        >
          {score ? `Accept ${score}` : 'Accept'}
        </Button>
      )}
      <Button
        color={canInlineAccept ? 'default' : 'primary'}
        variant={canInlineAccept ? 'outlined' : 'contained'}
        size="small"
        data-testid={`resolve-queue-item-${item.id}`}
        onClick={() => onOpenResolution(item)}
      >
        {canInlineAccept ? 'Review' : 'Resolve'}
      </Button>
    </Box>
  );
};

QueueActionCell.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    status: PropTypes.string,
  }).isRequired,
  onOpenResolution: PropTypes.func.isRequired,
  onInlineAccept: PropTypes.func,
};

QueueActionCell.defaultProps = {
  onInlineAccept: null,
};
